module.exports = __webpack_public_path__ + "static/media/linux_mint_bg.8c2194f7.png";